import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  itemContainer: {
    paddingLeft: theme.spacing(2)
  }
}));

export default useStyles;
